import _get from 'lodash/get';
import { ImmutableObject } from 'ia-react-core/~/interfaces/ImmutableObject';

/**
 * @visibleName get
 * @since 0.19.0
 * @component
 */
const get = (
  object: Parameters<typeof _get>[0],
  path: Parameters<typeof _get>[1],
  defaultValue?: Parameters<typeof _get>[2],
) => {
  // Duck checking immutable.js
  if (object && typeof object === 'object' && 'getIn' in object) {
    const normalizedPath = Array.isArray(path) ? path : String(path).split('.');
    return (object as ImmutableObject).getIn(normalizedPath as string[], defaultValue);
  }

  return _get(object, path, defaultValue) as object;
};

export default get as typeof _get;
